"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const react_hook_form_2 = require("react-hook-form");
const iconoir_react_1 = require("iconoir-react");
//import app components
const button_1 = __importDefault(require("../../elements/button"));
const input_1 = __importDefault(require("../../elements/input"));
const colors_1 = __importDefault(require("../../../theme/colors"));
const LoginForm = (props) => {
    const { loading, resetPasswordLink, onSubmit, linkComponent } = props;
    const { handleSubmit, control } = (0, react_hook_form_1.useForm)();
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    return (react_1.default.createElement("form", { method: "post", "data-testid": "loginForm", noValidate: true, onSubmit: (e) => {
            e.preventDefault();
            !loading && handleSubmit(onSubmit)(e);
        } },
        react_1.default.createElement(material_1.Stack, { spacing: 3 },
            react_1.default.createElement(react_hook_form_2.Controller, { name: "email", control: control, rules: {
                    required: "Please enter your email address",
                    pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email",
                    },
                }, render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(input_1.default, { label: "Email", inputProps: { "data-testid": "email" }, placeholder: "johndoe@workemail.com", onChange: onChange, error: !!error, helperText: error ? error.message : null, type: "email", fullWidth: true })) }),
            react_1.default.createElement(react_hook_form_2.Controller, { name: "password", control: control, defaultValue: "", render: ({ field: { onChange }, fieldState: { error } }) => (react_1.default.createElement(input_1.default, { label: "Password", inputProps: { "data-testid": "password" }, placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022", onChange: onChange, error: !!error, helperText: error ? error.message : null, type: showPassword ? "text" : "password", endIcon: showPassword ? react_1.default.createElement(iconoir_react_1.EyeEmpty, null) : react_1.default.createElement(iconoir_react_1.EyeOff, null), onClick: handleTogglePassword, fullWidth: true })), rules: { required: "Please enter your password" } }),
            resetPasswordLink && (react_1.default.createElement(material_1.Link, { component: linkComponent, variant: "body2", href: resetPasswordLink, underline: "hover", sx: {
                    color: colors_1.default.text[100],
                    display: "flex",
                    alignSelf: "end",
                } }, "Forgot Your Password?")),
            react_1.default.createElement(button_1.default, { loading: loading, variant: "outlined", type: "submit", "data-testid": "loginButton", fullWidth: true }, "Login"))));
};
exports.default = LoginForm;
